var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg034SgAppointmentScheduling = function Svg034SgAppointmentScheduling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 256c0-122.365 88.168-219.927 206-234.196A249.342 249.342 0 0 0 256 20C123.452 20 20 123.452 20 256s103.452 236 236 236c10.184 0 20.194-.616 30-1.804C168.168 475.927 80 378.365 80 256z",
    fill: "#a0eda2",
    "data-original": "#cee1f2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m392 416 40 40 60-60",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#14d64d",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#ff5cf4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.593 474.719C317.91 485.865 287.672 492 256 492 123.452 492 20 388.548 20 256S123.452 20 256 20s236 103.452 236 236c0 18.57-2.109 36.648-6.101 54.006",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336 336-80-80v-80m0-80h0m0 320h0M100 256h0m312 0h0",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }));
};

export default Svg034SgAppointmentScheduling;